"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Footer_component_1 = require("./Footer.component");
exports.Footer = Footer_component_1.Footer;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW5kZXguanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9mb3Jtcy9hc2hlci9Ub3VyUmVjYXAvcGFydHMvRm9vdGVyL2luZGV4LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsdURBQXlDO0FBQWpDLG9DQUFBLE1BQU0sQ0FBQSJ9